// src/actions/types.js

// Existing types
export const INCREMENT = 'INCREMENT';
export const DECREMENT = 'DECREMENT';
export const LOGIN = 'LOGIN';
export const USER_ROLE = 'USER_ROLE';
export const USER_LOGOUT = 'USER_LOGOUT';

// Cart Management
export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const UPDATE_CART_ITEM_QUANTITY = 'UPDATE_CART_ITEM_QUANTITY';
export const DOWNGRADE_CART_ITEM_QUANTITY = 'DOWNGRADE_CART_ITEM_QUANTITY';
export const UPDATE_CART_DISCOUNT = 'UPDATE_CART_DISCOUNT';
export const UPDATE_CART_ITEM = 'UPDATE_CART_ITEM';
export const CLEAR_CART = 'CLEAR_CART';
export const SET_ORDER_TYPE = 'SET_ORDER_TYPE';

// Global Discount Management
export const APPLY_GLOBAL_DISCOUNT = 'APPLY_GLOBAL_DISCOUNT';
export const REMOVE_GLOBAL_DISCOUNT = 'REMOVE_GLOBAL_DISCOUNT';

// Tax Management
export const APPLY_TAX = 'APPLY_TAX';
export const REMOVE_TAX = 'REMOVE_TAX';
export const SET_TAX_EXPLICIT = 'SET_TAX_EXPLICIT';

// Customer Management
export const SET_CUSTOMER = 'SET_CUSTOMER';
export const CLEAR_CUSTOMER = 'CLEAR_CUSTOMER';

// Table Management
export const ADD_TABLE = 'ADD_TABLE';
export const CLEAR_TABLE = 'CLEAR_TABLE';

// Order Management
export const ADD_TO_ORDER = 'ADD_TO_ORDER';
export const UPDATE_ORDER_ITEM_DISCOUNT = 'UPDATE_ORDER_ITEM_DISCOUNT';
export const REMOVE_FROM_ORDER = 'REMOVE_FROM_ORDER';
export const UPDATE_ORDER_ITEM_QUANTITY = 'UPDATE_ORDER_ITEM_QUANTITY';
export const UPDATE_ORDER_ITEM = 'UPDATE_ORDER_ITEM';
export const DOWNGRADE_ORDER_ITEM_QUANTITY = 'DOWNGRADE_ORDER_ITEM_QUANTITY';
export const CLEAR_ORDER = 'CLEAR_ORDER';

// Combo Management
export const ADD_COMBO_TO_CART = 'ADD_COMBO_TO_CART';
export const REMOVE_COMBO_FROM_CART = 'REMOVE_COMBO_FROM_CART';
export const UPDATE_COMBO_QUANTITY = 'UPDATE_COMBO_QUANTITY';
export const DOWNGRADE_COMBO_QUANTITY = 'DOWNGRADE_COMBO_QUANTITY';
export const CLEAR_COMBO_CART = 'CLEAR_COMBO_CART';

// Add-on Management (if needed in future)
export const ADD_ADDON = 'ADD_ADDON';
export const REMOVE_ADDON = 'REMOVE_ADDON';
export const UPDATE_ADDON_QUANTITY = 'UPDATE_ADDON_QUANTITY';

// Employee Management
export const SET_EMPLOYEE_DATA = 'SET_EMPLOYEE_DATA';

// User Rights Management
export const ADD_RIGHT = 'ADD_RIGHT';
export const CLEAR_RIGHT = 'CLEAR_RIGHT';

// Payment Management
export const SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD';
export const SET_PAYMENT_STATUS = 'SET_PAYMENT_STATUS';

// Order Status Management
export const SET_ORDER_STATUS = 'SET_ORDER_STATUS';
export const UPDATE_ORDER_STATUS = 'UPDATE_ORDER_STATUS';

// Promotion Management
export const APPLY_PROMOTION = 'APPLY_PROMOTION';
export const REMOVE_PROMOTION = 'REMOVE_PROMOTION';

// Settings
export const SET_CURRENCY = 'SET_CURRENCY';
export const SET_RESTAURANT_INFO = 'SET_RESTAURANT_INFO';
export const UPDATE_ORDER_ITEM_VOID = 'UPDATE_ORDER_ITEM_VOID';
export const UPDATE_ORDER_ITEM_REFUND = 'UPDATE_ORDER_ITEM_REFUND';
export const SET_ORDER_DATA = 'SET_ORDER_DATA';

export const UPDATE_ORDER_ITEM_INSTRUCTIONS = 'UPDATE_ORDER_ITEM_INSTRUCTIONS';
export const SET_USER_ID = 'SET_USER_ID';
